import React, { ReactElement } from 'react';

const Tab = (props: {name: string, hidden?: boolean, children: ReactElement[] | ReactElement}) => {
    if(props.hidden) return null;
    
    return (
        <div className="tab">
            {props.children}
        </div>
    );
};

export default Tab;
